module.exports = __webpack_public_path__ + "static/carbon-select-750aefdfbec27e18d3f572561d6dc5bc.png";